import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useAdvertiser } from "@redux/advertiser";
import { DefaultContainedButton } from "@assets/buttons";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 630,
  // height: 530,
  // maxHeight: { xl: 700, lg: 700, md: 600, sm: 500, xs: "calc(100% - 32px)" },
  overflow: "scroll",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 0,
  borderRadius: "24px",
  pt: 10,
  pl: 9.375,
  pr: 9.375,
  pb: 7.5,
};

const AdvertiserComplete = ({
  open,
  target,
  onClick,
  onClose,
  onNewRows,
  onListUpdate,
  onNewRowsFilter,
  userId,
  name,
  email,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Grid container justifyContent="center">
          <Typography
            variant="h2"
            fontWeight={500}
            sx={{ color: "#424242" }}
            align="center"
          >
            광고주 등록 완료!
          </Typography>
        </Grid>
        <Grid container sx={{ pt: 5.625, pb: 5.625 }} direction="column">
          <Grid
            container
            direction="column"
            sx={{
              backgroundColor: "#FAFAFC",
              borderRadius: "10px",
              pt: 4.375,
              pb: 4.375,
              pr: 12.5,
              pl: 12.5,
            }}
          >
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ pt: 1.5 }}
            >
              <Grid sx={{ width: 95 }}>
                <Typography variant="body" sx={{ color: "grey.700" }}>
                  광고명
                </Typography>
              </Grid>
              <Grid sx={{ flexGrow: 1 }}>
                <Typography variant="body" sx={{ color: "grey.700" }}>
                  {name}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ pt: 1.5 }}
            >
              <Grid sx={{ width: 95 }}>
                <Typography variant="body" sx={{ color: "grey.700" }}>
                  이메일
                </Typography>
              </Grid>
              <Grid sx={{ flexGrow: 1 }}>
                <Typography variant="body" sx={{ color: "grey.700" }}>
                  {email}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ pt: 1.5 }}
            >
              <Grid sx={{ width: 95 }}>
                <Typography variant="body" sx={{ color: "grey.700" }}>
                  아이디
                </Typography>
              </Grid>
              <Grid sx={{ flexGrow: 1 }}>
                <Typography variant="body" sx={{ color: "grey.700" }}>
                  {userId}
                </Typography>
              </Grid>
            </Grid>
            {/* <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ pt: 1.5 }}
            >
              <Grid sx={{ width: 95 }}>
                <Typography variant="body" sx={{ color: "grey.700" }}>
                  비밀번호
                </Typography>
              </Grid>
              <Grid sx={{ flexGrow: 1 }}>
                <Typography variant="body" sx={{ color: "grey.700" }}>
                  ****
                </Typography>
              </Grid>
            </Grid> */}
          </Grid>
        </Grid>
        <Grid container justifyContent="center" alignItems="center">
          <Grid sx={{ width: 210 }}>
            <DefaultContainedButton
              color="primary"
              fullWidth={true}
              height={56}
              borderColor="primary.main"
              fontWeight={500}
              text="확인"
              onClick={onClick}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default AdvertiserComplete;
